import { FC } from 'react';

import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledInviteNotificationBanner from './styles';

const RExpandTeamBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledInviteNotificationBanner>
      <Typography.Text className="fs-12-bold text-dark-color">
        {t('components.expandTeamBanner.needMoreSpace')}
      </Typography.Text>

      <Typography.Text className="fs-12-regular text-dark-color">
        {t('components.expandTeamBanner.inviteMorePeople')}
      </Typography.Text>
    </StyledInviteNotificationBanner>
  );
};

export default RExpandTeamBanner;
